import styled, { css } from 'styled-components';
import { isFormValidationErrorDisplayed } from '../../common.types.js';
import { OnFocusInput } from '../common/index.js';
export const BKJDropdown = styled.ul `
  will-change: transform, height;

  &&& {
    overflow-y: overlay;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
      background: transparent;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #aeb8c5;
      border-radius: 4.5px;
      position: relative;
      right: 4px;
    }
  }
  height: auto;
  max-height: 304px;
  z-index: 1000;
  width: unset;
  overflow-y: overlay;

  ${({ $dropdownWidth }) => $dropdownWidth &&
    css `
      width: ${$dropdownWidth};
      max-width: ${$dropdownWidth};
      min-width: ${$dropdownWidth};
    `};

  ${({ $dropdownHeight }) => $dropdownHeight &&
    css `
      height: ${$dropdownHeight};
      max-height: ${$dropdownHeight};
      min-height: ${$dropdownHeight};
    `};

  ${({ $dropdownMinHeight }) => $dropdownMinHeight &&
    css `
      height: ${$dropdownMinHeight};
      max-height: ${$dropdownMinHeight};
      min-height: ${$dropdownMinHeight};
    `};

  ${({ $dropdownVariant, theme }) => theme.dropdown[$dropdownVariant]};
  ${({ error, theme }) => {
    if (isFormValidationErrorDisplayed(error))
        return css `
        border-color: ${theme.colors.ErrorDefault};
      `;
    else
        return css ``;
}};
  ${(props) => {
    const isRefHidden = props['data-popper-reference-hidden'];
    if (isRefHidden)
        return css `
        visibility: hidden;
        pointer-events: none;
      `;
    return css ``;
}};

  ${({ $isOpen, openBorderLocation }) => $isOpen &&
    css `
      border: none;
      ${OnFocusInput({ openBorderLocation })};
    `}
`;
//# sourceMappingURL=BKJDropdown.js.map